// extracted by mini-css-extract-plugin
export default {"container":"OaAnYfS6","profileCard":"l2EbwwLq","profileHeader":"ffSGStQh","avatar":"fVk_2la1","descriptions":"wIuCVV8G","actions":"fSWHNPlr","ant-btn":"zdhOoR8W"};